import React from "react";
import { Box, IconButton } from "@material-ui/core";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

export default function TableSortHeader({
  keyName,
  viewName,
  orderBy,
  order,
  onCycleSort,
  onSortAsc,
  onSortDesc,
  classes,
}) {
  const isActive = orderBy === keyName;
  const isAsc = isActive && order === "asc";
  const isDesc = isActive && order === "desc";

  return (
    <Box display="flex" alignItems="center">
      <TableSortLabel data-key={keyName} onClick={onCycleSort} hideSortIcon>
        {viewName}
        {isActive ? (
          <span className={classes.visuallyHidden}>
            {order === "desc" ? "sorted descending" : "sorted ascending"}
          </span>
        ) : null}
      </TableSortLabel>
      <Box className={classes.sortButtons}>
        <IconButton
          size="small"
          color={isAsc ? "primary" : "default"}
          onClick={onSortAsc}
          aria-label={`Sort ${viewName} ascending`}
        >
          <ArrowUpwardIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          color={isDesc ? "primary" : "default"}
          onClick={onSortDesc}
          aria-label={`Sort ${viewName} descending`}
        >
          <ArrowDownwardIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
